import Login from './pages/auth/Login.vue';
import Order from './pages/order/Order.vue'
import News from './pages/news/News.vue'
import Achievement from './pages/achievement/Achievement';
import Company from './pages/company/Company.vue';

import Project from './pages/project/Project.vue'

import Demand from './pages/demand/Demand.vue'
import DemandDomain from './pages/demand/domain/Domain';
import DemandApplication from './pages/demand/application/Application.vue';
import DemandOrder from './pages/demand/order/Order.vue';

import Technique from './pages/technique/Technique.vue'
import TechniqueDomain from './pages/technique/domain/Domain';
import TechniqueOrder from './pages/technique/order/Order.vue';

import Specialist from './pages/specialist/Specialist.vue'
import SpecialistDomain from './pages/specialist/domain/Domain';
import SpecialistOrder from './pages/specialist/order/Order.vue';

import Admin from './pages/sa/admin/Admin.vue'

import Error401 from './pages/error/401';
import Error403 from './pages/error/403';
import Error404 from './pages/error/404';

export default [
    {
        path: '/login',
        component: Login,
        meta: {layout: 'blank'}
    },{
        path: '/order',
        component: Order,
        name: '最新订单'
    },{
        path: '/news',
        component: News,
        name: '新闻'
    },{
        path: '/achievement',
        component: Achievement,
        name: '科技成果'
    },{
        path: '/company',
        component: Company,
        name: '公司'
    },{
        path: '/project',
        component: Project,
        name: '项目'
    },{
        path: '/demand',
        component: Demand,
        name: '需求'
    },{
        path: '/demand/domain',
        component: DemandDomain,
        name: '需求分类'
    },{
        path: '/demand/application',
        component: DemandApplication,
        name: '需求发布申请'
    },{
        path: '/demand/order',
        component: DemandOrder,
        name: '需求订单'
    },{
        path: '/technique',
        component: Technique,
        name: '技术'
    },{
        path: '/technique/domain',
        component: TechniqueDomain,
        name: '技术分类'
    },{
        path: '/technique/order',
        component: TechniqueOrder,
        name: '技术订单'
    },{
        path: '/specialist',
        component: Specialist,
        name: '专家'
    },{
        path: '/specialist/domain',
        component: SpecialistDomain,
        name: '专家分类'
    },{
        path: '/specialist/order',
        component: SpecialistOrder,
        name: '专家订单'
    },{
        path: '/sa/admin',
        meta: {saOnly:true},
        component: Admin,
        name: '管理员'
    },{
        path: '/401',
        meta: {layout: 'blank'},
        component: Error401
    },{
        path: '/403',
        component: Error403
    },{
        path: '/',
        redirect: '/order'
    },{
        path: '*',
        component: Error404
    }
]